import React from 'react'
import './SocialFormStyles.css'
import {FaFacebook, FaTwitter, FaSpotify, FaSoundcloud, FaInstagram} from 'react-icons/fa'


function SocialForm() {
  return (
    <div className='socialForm'>
        <div className='socials'>
            <h1>Socials</h1>
            <div className='icons'>
                <a href=' https://www.facebook.com/ShipWrekDJ'>
                    <FaFacebook size={40} style={{color:'#ffffff', marginRight:'2rem'}}/>
                </a>
                <a href='https://www.instagram.com/shipwrekdj/?hl=en'>
                    <FaInstagram size={40} style={{color:'#ffffff', marginRight:'2rem'}}/>
                </a>
                <a href='https://soundcloud.com/THESHIPWREK'>
                    <FaSoundcloud size={40} style={{color:'#ffffff', marginRight:'2rem'}} onMouseEnter={{backgroundColor:'red'}}/>
                </a>
                <a href='https://open.spotify.com/artist/1ic0FHNGIjXZAWH6O6Reif'>
                    <FaSpotify size={40} style={{color:'#ffffff', marginRight:'2rem'}}/>
                </a>
                
                <a href='https://twitter.com/ShipWrekDJ?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor'>
                    <FaTwitter size={40} style={{color:'#ffffff', marginRight:'2rem'}}/>
                </a>
                
                
                
            </div>
        </div>
        <div className='form'>
            <h1>Contact</h1>
            <form>
                <label>Name</label>
                <input type='text'></input>
                <label>Email</label>
                <input type='text'></input>
                <label>Subject</label>
                <input type='text'></input>
                <label>Details</label>
                <textarea rows='6' placeholder='Type details here'></textarea>
                <button className='btn'>Submit</button>
            </form>
        </div>
    </div>
  )
}

export default SocialForm